// extracted by mini-css-extract-plugin
export default {"page":"style_page__vpg4z","emoji":"style_emoji__7YN8u","title":"style_title__IwXqF","subtitle":"style_subtitle__DKeYS","spacer":"style_spacer__O8bAa"};